import gql from 'graphql-tag';

export default gql`
  query getUnreviewedOrderItems($input: GetUnreviewedOrderItemsInput!) {
    getUnreviewedOrderItems(input: $input) {
      data {
        orderId
        fulfillmentShortCode
      }
      success
      userErrors {
        field
        message
      }
    }
  }
`;
